import React from 'react';

import BulkImportModal from '../components/bulkImportModal';

import getAxiosConfig from './getAxiosConfig';

export default (model) => ({
  component: (
    <BulkImportModal
      getEnqueueAxiosConfig={(data) => getAxiosConfig('enqueue-enrollments-import', data)}
      getPreviewAxiosConfig={(data) => getAxiosConfig('create-enrollments-import', data)}
      initialData={model}
      settingsAxiosConfig={getAxiosConfig('get-enrollments-import-settings', { type: model.type })}
      typeKey="enrollment"
    />
  ),
  hasCloseButton: true,
  isFullScreen: true,
});
